import styled from 'styled-components';


export const StyledFilterPill = styled.div`
  background: #f2f2f2;
  border-radius: 1.875rem;
  padding: 0.5625rem 1rem;
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 1rem;
`;
